import React, { Component, Fragment } from 'react'
import Submit from './Messaging/Submit.js'

export default class Messaging extends Component {

    componentDidMount() {
        document.title = 'Send a Message';
    }

    render () {
        return (
            <Fragment>
                <div id="heading">
                    <h1>Send a Message</h1>
                </div>
                <section id="main" className="wrapper">
                    <div className="inner">
                        <Submit />
                    </div>
                </section>
            </Fragment>
        )
    }
}